import { Badge, Box, Inline, Text } from 'braid-design-system';
import type { FC } from 'react';
import * as styles from './styles.css';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';

interface StatusButtonProps {
  label: string;
  newCount?: number;
  count: number;
  selected: boolean;
  onClick: () => void;
}

export const FilterStatusButtonMobile: FC<StatusButtonProps> = ({
  count,
  label,
  selected,
  newCount,
  onClick,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box
      component="button"
      cursor="pointer"
      onClick={() => onClick()}
      width="full"
      className={{
        [styles.statusFolderLayout]: true,
        [styles.statusFolderSelected]: selected,
        [styles.statusFolderNotSelected]: !selected,
      }}
    >
      <Inline space="small" alignY="center">
        <Text weight="strong" size="small" tone={selected ? 'info' : 'neutral'}>
          {label}
        </Text>
        {newCount !== undefined ? (
          <Badge bleedY tone="positive">
            {t('newCount New', { newCount })}
          </Badge>
        ) : null}
      </Inline>
      <Box
        className={{
          [styles.badge]: true,
          [styles.badgeActive]: selected,
          [styles.countBadgeInactive]: !selected,
        }}
        aria-label={t('count applications', { count })}
      >
        <Text size="small" weight="medium" tone={selected ? 'info' : 'neutral'}>
          {count}
        </Text>
      </Box>
    </Box>
  );
};
